module.exports = __webpack_public_path__ + "img/bigroot.89602035.svg";